export default {
  fields: {
    sales: {
      label: 'Ventes',
    },
    gift_cards_sales: {
      label: 'Ventes de cartes-cadeaux',
    },
    average_order_value: {
      label: 'Valeur moyenne des commandes',
    },
    savings: {
      label: 'Économies sur les frais tiers',
    },
    reservations: {
      label: 'Réservations',
    },
    sales_from_email: {
      label: 'Ventes par e-mail',
    },
    sales_from_google_seo: {
      label: 'Ventes via Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Ventes via Google Business',
    },
    sales_from_google_ads: {
      label: 'Ventes via Google Ads',
    },
    sales_from_flyers: {
      label: 'Ventes via prospectus',
    },
    sales_from_social_media: {
      label: 'Ventes via réseaux sociaux',
    },
    sales_from_facebook_ads: {
      label: 'Ventes via Facebook Ads',
    },
    tips: {
      label: 'Pourboires',
    },
    new_customers: {
      label: 'Nouveaux clients',
    },
    returning_customers: {
      label: 'Clients fidèles',
    },
    new_visitors: {
      label: 'Nouveaux visiteurs',
    },
    new_followers: {
      label: 'Nouveaux abonnés',
    },
    total_followers: {
      label: 'Total des abonnés',
    },
    delivered_messages: {
      label: 'Messages délivrés',
    },
    average_open_rate: {
      label: "Taux d'ouverture moyen des e-mails",
    },
    average_click_rate: {
      label: 'Taux de clics moyen',
    },
    website_visitors_from_email: {
      label: 'Visiteurs du site via e-mail',
    },
    sales_from_google_business: {
      label: 'Ventes via Google Business',
    },
    total_reservations: {
      label: 'Réservations',
    },
    website_visitors_from_google_seo: {
      label: 'Clics sur le site via Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Clics sur le site via Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Clics sur le site via Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Clics sur le site via réseaux sociaux',
    },
    calls_from_google_ads: {
      label: 'Appels via Google Ads',
    },
    directions_from_google_ads: {
      label: 'Itinéraires via Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Réseaux sociaux',
    },
    flyer_orders_count: {
      label: 'Prospectus',
    },
    email_orders_count: {
      label: 'E-mails',
    },
    other_orders_count: {
      label: 'Autres',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Cartes-cadeaux',
    },
    net_billed_revenue: {
      label: 'Revenus facturés (NET)',
    },
    net_billed_revenue_subscription: {
      label: "Revenus d'abonnement facturés",
    },
    net_billed_revenue_service_fee: {
      label: 'Revenus de frais de service facturés',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Revenus des frais de livraison facturés',
    },
    net_billed_revenue_other: {
      label: 'Revenus des frais de service facturés',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Livraison facturée - Pass-through',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Revenus des frais de traitement plateforme facturés',
    },
    gross_cash_income: {
      label: 'Revenus cash (Brut)',
    },
    gross_cash_income_subscription: {
      label: 'Revenus cash des abonnements',
    },
    gross_cash_income_service_fee: {
      label: 'Revenus cash des frais de service',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Revenus cash des frais de livraison',
    },
    gross_cash_income_other: {
      label: 'Revenus cash des charges de service',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Revenus cash des frais de livraison pass-through',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Revenus cash des frais de traitement plateforme',
    },
    net_cash_income: {
      label: 'Revenus cash (NET)',
    },
    net_cash_income_subscription: {
      label: 'Revenus cash des abonnements',
    },
    net_cash_income_service_fee: {
      label: 'Revenus cash des frais de service',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Revenus cash des frais de livraison',
    },
    net_cash_income_other: {
      label: 'Revenus cash des charges de service',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Revenus cash des frais de livraison pass-through',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Revenus cash des frais de traitement plateforme',
    },
    manual_connect_transfers: {
      label: 'Remboursé aux restaurants',
    },
    processing_fees: {
      label: 'Frais de traitement',
    },
    processing_fees_stripe: {
      label: 'Frais de traitement (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Frais de traitement (PayPal)',
    },
    rejected_orders: {
      label: 'Commandes rejetées',
    },
    rejected_orders_amount: {
      label: 'Montant des commandes rejetées',
    },
    rejected_orders_count: {
      label: 'Nombre de commandes rejetées',
    },
    rejected_orders_rate: {
      label: 'Taux de commandes rejetées',
    },
    rejected_orders_rate_breakdown: {
      label: 'Détail du taux de commandes rejetées',
    },
    orders: {
      label: 'Commandes',
    },
    total_orders: {
      label: 'Total des commandes',
    },
    pickup_orders_rate: {
      label: 'Taux de commandes à emporter',
    },
    delivery_orders_rate: {
      label: 'Taux de commandes en livraison',
    },
    other_orders_rate: {
      label: "Taux d'autres commandes",
    },
    customers: {
      label: 'Total clients',
    },
    customers_auth_state: {
      label: "État d'authentification client",
    },
    website_reservations: {
      label: 'Réservations web',
    },
    google_reservations: {
      label: 'Réservations Google',
    },
    companies: {
      label: 'Entreprises',
    },
    live_companies: {
      label: 'Restaurants actifs',
    },
    live_companies_percentage: {
      label: '% restaurants actifs',
    },
    setup_packages_breakdown: {
      label: "Forfaits d'installation",
    },
    setup_packages_billing_mode_breakdown: {
      label: "Forfaits d'installation par source de facturation",
    },
    crossed_sales_level_this_month: {
      label: 'Palier de ventes atteint ce mois',
    },
    crossed_sales_level_total: {
      label: 'Palier de ventes atteint (total)',
    },
    crossed_sales_level_percentage: {
      label: '% palier de ventes atteint',
    },
    has_delivery: {
      label: 'Livraison propre',
    },
    has_only_pickup: {
      label: 'Retrait uniquement',
    },
    has_storefront: {
      label: 'A une vitrine',
    },
    has_storefront_percentage: {
      label: '% vitrine',
    },
    use_external_delivery: {
      label: 'Livraison externe',
    },
    crossed_sales: {
      label: 'Franchi {{value}} ventes',
    },
    restaurant_partners: {
      label: 'Restaurants partenaires',
    },
    registered_restaurants: {
      label: 'Restaurants enregistrés',
    },
    signed_restaurants: {
      label: 'Restaurants signés',
    },
    use_reservations: {
      label: 'Utilise les réservations',
    },
    number: {
      label: 'Nombre',
    },
    restaurants_percentage: {
      label: '% restaurants',
    },
    crossed_sales_level: {
      label: 'Palier de ventes atteint',
    },
    order_method: {
      label: 'Mode de commande',
    },
    own_delivery: {
      label: 'Livraison propre',
    },
    only_pickup: {
      label: 'Retrait uniquement',
    },
    storefront: {
      label: 'Vitrine',
    },
    sales_tiers: {
      label: 'Paliers de ventes',
    },
    new_pricing_adoption_rate: {
      label: "Taux d'adoption de la nouvelle tarification",
    },
    mobile_app_attach_rate: {
      label: "Taux d'adoption de l'app mobile",
    },
    mobile_app_setup_fee_breakdown: {
      label: "Frais d'installation app mobile choisis",
    },
    first_delivery: {
      label: 'Uber (Première livraison)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Nombre de devis de livraison',
    },
    deliveries_count: {
      label: 'Nombre de livraisons',
    },
    delivery_conversion: {
      label: 'Taux de conversion livraison',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Devis de livraison par prestataire',
    },
    deliveries_provider_breakdown: {
      label: 'Livraisons par prestataire',
    },
    delivery_distance_breakdown: {
      label: 'Répartition par distance de livraison',
    },
    total_delivered: {
      label: 'Messages délivrés',
    },
    website_visitors_from_google_business_profile: {
      label: 'Clics site web depuis Google Business',
    },
    google_business_impressions: {
      label: 'Impressions depuis Google Business',
    },
    google_business_website_clicks: {
      label: 'Clics site web depuis Google Business',
    },
    google_ads_impressions: {
      label: 'Impressions Google Ads',
    },
    google_ads_clicks: {
      label: 'Clics Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Appels Google Ads',
    },
    google_ads_directions: {
      label: 'Itinéraires Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: '% moy. impressions top absolu Google Ads',
    },
    google_ads_average_cpc: {
      label: 'CPC moyen Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Taux moy. de conversions par interaction Google Ads',
    },
    website_visits: {
      label: 'Visites du site',
    },
    website_visitors: {
      label: 'Visiteurs du site',
    },
    companies_with_activated_reservations: {
      label: 'Restaurants avec réservations activées',
    },
    online_orders_count: {
      label: 'Commandes en ligne',
    },
    cash_orders_count: {
      label: 'Commandes en ligne',
    },
    cash_sales: {
      label: 'Ventes en espèces',
    },
    online_sales: {
      label: 'Ventes en ligne',
    },
    payouts: {
      label: 'Virements',
    },
    last_payout_amount: {
      label: 'Dernier virement',
    },
    pending_payout_amount: {
      label: 'En transit',
    },
    future_payout_amount: {
      label: 'Disponible pour futurs virements',
    },
    mobile_app_average_order_value: {
      label: 'Panier moyen via app',
    },
    mobile_app_gmv: {
      label: 'Ventes totales via app',
    },
    mobile_app_gmv_percentage: {
      label: '% revenus via app',
    },
    mobile_app_downloads: {
      label: 'Total téléchargements app',
    },
    mobile_app_orders_count: {
      label: 'Total commandes via app',
    },
    net_billed_revenue_gift_cards: {
      label: 'Revenus des cartes-cadeaux facturées',
    },
    gross_cash_income_gift_cards: {
      label: 'Revenus cash des cartes-cadeaux',
    },
    net_cash_income_gift_cards: {
      label: 'Revenus cash des cartes-cadeaux',
    },
    platform_processing_fees: {
      label: 'Frais de traitement plateforme',
    },
  },
};
